import Card from "./card.js";
export default class CaptionedImage extends Card {
  constructor(t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f) {
    super(t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f),
      (this.oe = "ab-captioned-image"),
      (this.ae = !0),
      (this.test = !1);
  }
  bt() {
    const t = {};
    return (
      (t[Card.es.hs] = Card.cs.os),
      (t[Card.es.ds] = this.id),
      (t[Card.es.ps] = this.viewed),
      (t[Card.es.us] = this.title),
      (t[Card.es.ls] = this.imageUrl),
      (t[Card.es.fs] = this.description),
      (t[Card.es.xs] = this.updated),
      (t[Card.es.bs] = this.created),
      (t[Card.es.gs] = this.categories),
      (t[Card.es.js] = this.expiresAt),
      (t[Card.es.URL] = this.url),
      (t[Card.es.zs] = this.linkText),
      (t[Card.es.ks] = this.aspectRatio),
      (t[Card.es.qs] = this.extras),
      (t[Card.es.vs] = this.pinned),
      (t[Card.es.ws] = this.dismissible),
      (t[Card.es.ys] = this.clicked),
      (t[Card.es.As] = this.test),
      t
    );
  }
}
